import React from 'react';
import PropTypes from 'prop-types';

import {
  EMBEDDED_MICROSTRIP,
  MICROSTRIP,
  ASYMMETRIC_STRIPLINE,
  STRIPLINE,
 } from '../../../../../constants/globals';
import microstrip from './microstrip.svg';
import embeddedMicrostrip from './embedded-microstrip.svg';
import symmetricStripline from './symmetric-stripline.svg';
import asymmetricStripline from './asymmetric-stripline.svg';

const findFile = (simulationModel) => {
  switch (simulationModel) {
    case MICROSTRIP:
      return microstrip;
    case EMBEDDED_MICROSTRIP:
      return embeddedMicrostrip;
    case STRIPLINE:
      return symmetricStripline;
    case ASYMMETRIC_STRIPLINE:
      return asymmetricStripline;
    default:
      return '';
  }
}

export function SimulationModelImg({
  className,
  simulationModel
}){
  const src = findFile(simulationModel);
  return <img src={src} alt={simulationModel} className={className} />;
}

SimulationModelImg.propTypes = {
  className: PropTypes.string,
  simulationModel: PropTypes.string,
}

SimulationModelImg.defaultProps = {
  className: {},
  simulationModel: ''
}

export default SimulationModelImg;


// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/ResultViewer/SimulationModelImg/SimulationModelImg.jsx